import ChatNavigationSettingsModal from './ChatNavigationSettingsModal';

export default ChatNavigationSettingsModal;
